import { t } from '../../../shared/config/translations'

const titles = {
	'app-settings': 'settings.appSettings',
	'contact-feedback': 'settings.contactFeedback',
	'report-bug': 'settings.reportBug',
	'whats-new': 'settings.whatsNew',
	'privacy-policy': 'settings.privacyPolicy',
	'terms-service': 'settings.termsService',
} as const

export type SettingsOverlayKey = keyof typeof titles

export function settingsOverlayPath(key: SettingsOverlayKey): string {
	return `/setting/${encodeURIComponent(t(titles[key]))}`
}

export function resolveSettingsOverlay(
	path: string,
): SettingsOverlayKey | undefined {
	if (!path.startsWith('/setting/')) return undefined
	try {
		const title = decodeURIComponent(path.slice('/setting/'.length))
		return (Object.keys(titles) as SettingsOverlayKey[]).find(
			(key) => t(titles[key]) === title || key === title,
		)
	} catch {
		return undefined
	}
}
